import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Pipe,
  PipeTransform,
  SecurityContext,
  inject,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { parseMarkdownToHtml } from '../plugins/rich-editor-update-markdown-content/md-to-html-util';

@Pipe({ name: 'markdownToSafeHtml', standalone: true })
export class MarkdownToSafeHtmlPipe implements PipeTransform {
  private _sanitizer = inject(DomSanitizer);
  transform(markdown: string): string | null {
    const html = parseMarkdownToHtml(markdown);
    const sanitizedHtml = this._sanitizer.sanitize(SecurityContext.HTML, html);

    if (!sanitizedHtml) {
      return null;
    }

    return sanitizedHtml;
  }
}

@Component({
  selector: 'app-markdown-viewer',
  standalone: true,
  imports: [CommonModule, MarkdownToSafeHtmlPipe],
  templateUrl: './markdown-viewer.component.html',
  styleUrls: ['./markdown-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkdownViewerComponent {
  @Input() content: string;
  @Input() styleClass: any;
}
